export const layoutNames = [
  'defaultFormLayout',
  'defaultBannerLayout',
  'defaultQuestionLayout',
  'defaultOfferWallLayout',
  'defaultIframeLayout',
];

export const containerNames = [
  'defaultFormContainer',
  'defaultBannerContainer',
  'defaultQuestionContainer',
  'defaultOfferWallContainer',
  'defaultIframeContainer',
];

export const offerTypeNames = ['Form', 'Banner', 'Question', 'Offer Wall', 'Iframe'];

/**
 * ZET-4795 — offer type (id 11) of the hidden wrapper offers that let a Destination,
 * Linkout Waterfall, or Destination Waterfall be placed directly into a sequence. These
 * nodes are position-only: everything about them is configured on the Offer Actions
 * screen, so the sequence builder shows them read-only and applies no container/layout.
 */
export const DESTINATION_OFFER_TYPE_NAME = 'Destination';
